import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import MenuItem from 'material-ui/MenuItem';
import {roles} from '../../authentication/constants';
import SelectField from 'material-ui/SelectField';
import {withRouter} from 'react-router';
import {getCurrentUserId, getCurrentUserRole} from '../../authentication/selectors';
import {List, Map} from 'immutable';
import {loadAllStates, loadStateMandate, setSelectedState} from '../actions';
import {MainContent, Page, PageBody, PageHeader, SideNavigationBar} from '../../layout/components';
import React, {Component, PropTypes} from 'react';

class StateMandateDetailPage extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const {userId, userRole, loadAllStates, loadStateMandate, params} = this.props;
    const {characterId} = params;
    const selectedState = userRole === roles.ADMIN ? this.props.selectedState : null;

    loadAllStates();
    loadStateMandate(userId, characterId, selectedState);
  }

  handleStateSelection(event, index, value) {
    const {setSelectedState, userId, params, loadStateMandate} = this.props;
    const {characterId} = params;

    setSelectedState(value);
    loadStateMandate(userId, characterId, value);
  }

  stateMenuItems() {
    const {states} = this.props;
    return states.map(state => <MenuItem key={state.get('id')} value={state.get('abbrev')} primaryText={state.get('name')} />);
  }

  render() {
    const {loading, model, selectedState, userRole} = this.props;

    return (
      <Page pageClassName="state-mandate-detail-page">
        <PageHeader title={loading ? '' : `${model.get('careerPathway')} / ${model.get('userStateName')}`} />
        <PageBody>
          <SideNavigationBar />
          <MainContent hideRainbow loading={loading}>
            {
              userRole === roles.ADMIN
              ? <SelectField
                value={selectedState}
                floatingLabelText="State"
                onChange={this.handleStateSelection}>
                {this.stateMenuItems()}
              </SelectField>
              : null
            }
            {
              model.get('mandateContent')
              ? <div className="state-mandate-detail" dangerouslySetInnerHTML={{__html: model.get('mandateContent')}} />
              : <div className="no-mandate-message">No policies, standards or mandates exist for this state.</div>
            }
          </MainContent>
        </PageBody>
      </Page>
    );
  }
}

StateMandateDetailPage.propTypes = {
  loadAllStates: PropTypes.func.isRequired,
  loadStateMandate: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  model: PropTypes.instanceOf(Map).isRequired,
  params: PropTypes.object.isRequired,
  selectedState: PropTypes.string.isRequired,
  setSelectedState: PropTypes.func.isRequired,
  states: PropTypes.instanceOf(List).isRequired,
  userId: PropTypes.number.isRequired,
  userRole: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const {showStateMandate} = state.features.stateMandates.pages;

  return {
    loading: showStateMandate.get('loading'),
    model: showStateMandate.get('model'),
    selectedState: showStateMandate.get('selectedState'),
    states: showStateMandate.get('states'),
    userId: getCurrentUserId(state),
    userRole: getCurrentUserRole(state),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadAllStates,
    loadStateMandate,
    setSelectedState,
  }
)(StateMandateDetailPage));



// WEBPACK FOOTER //
// ./app/features/stateMandates/components/StateMandateDetailPage.js